import React from "react";
import EmptyCaseDialogMessage from "../../EmptyCaseDialogMessage";

interface MyBetsEmptyStateProps {
  title?: string;
  message?: string;
  qaLabel?: string;
}

const MyBetsEmptyStateCard: React.FC<MyBetsEmptyStateProps> = ({
  qaLabel = "mybets-empty-state",
  title,
  message
}) => (
  <EmptyCaseDialogMessage
    title={title || "No active bets"}
    description={message || "Any Bet in this race will appear here"}
    qaLabel={qaLabel}
    iconName="bets"
  />
);

export default MyBetsEmptyStateCard;
